import React, { useState, useEffect } from 'react';
import { paises } from '../data/Countries';
import logoSC from '../../images/logoSC.png';
import { User, Crown, Trophy, Gift, DollarSign, Rocket, Heart, Lock, Save, AlertCircle, CheckCircle } from 'lucide-react';
import { getUserById, changePassword, updateUser } from '../http/Actions/UsuariosAction';
import { jwtDecode } from 'jwt-decode';

const PremiumView = () => {
    return (
      <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black">
        <div className="flex items-center mb-6">
          <Crown className="text-yellow-500 mr-3" size={32} />
          <h2 className="text-3xl font-bold text-yellow-500">Premium</h2>
        </div>
        <div className="bg-gray-800 rounded-lg p-6 border-2 border-yellow-500/30 shadow-lg">
          <p className="text-white mb-6 text-lg">Tu cuenta no es Premium, para comenzar tu suscripción, puedes realizarlo desde el siguiente enlace</p>
          <div className="bg-gradient-to-br from-gray-700 to-gray-800 rounded-lg p-6 border border-yellow-500/20">
            <button className="w-full bg-yellow-600 hover:bg-yellow-700 text-white py-3 px-6 rounded-lg font-bold text-lg transition-all duration-300 shadow-md">
              <Crown className="inline mr-2" size={20} />
              Suscribirse a Premium
            </button>
            <p className="text-gray-400 text-center mt-4">La forma rápida y segura de pagar</p>
          </div>
        </div>
      </div>
    );
  };

  const MisPuntosView = () => {
    return (
      <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black text-white">
        <div className="flex items-center mb-6">
          <Trophy className="text-orange-500 mr-3" size={32} />
          <h2 className="text-3xl font-bold text-orange-500">Mis puntos</h2>
        </div>
        <div className="bg-gray-800 rounded-lg p-8 border-2 border-orange-500/30 shadow-lg">
          <div className="text-center mb-8">
            <p className="text-2xl mb-4">
              Actualmente tienes <span className="text-orange-500 font-bold text-4xl">0</span> puntos
            </p>
            <p className="text-xl text-gray-300">
              ¡Próximamente podrás canjearlos por recompensas!
            </p>
          </div>
          <div className="flex justify-center">
            <img src={logoSC} alt="Logo" className="w-80 h-64 object-contain" />
          </div>
        </div>
      </div>
    );
  };

  const InvitaYGanaView = () => {
    return (
      <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black text-white">
        <div className="flex items-center mb-6">
          <Gift className="text-purple-500 mr-3" size={32} />
          <h2 className="text-3xl font-bold text-purple-500">Invita y Gana</h2>
        </div>
        <div className="bg-gray-800 rounded-lg p-8 border-2 border-purple-500/30 shadow-lg">
          <div className="flex flex-col items-center">
            <div className="bg-white p-4 rounded-lg shadow-xl mb-6">
              <img 
                src="https://www.codigos-qr.com/qr/php/qr_img.php?d=https%3A%2F%2Fstupidcomedy.tv%2F&s=6&e=m" 
                alt="QR Code" 
                className="w-64 h-64"
              />
            </div>
            <p className="text-center max-w-md text-lg text-gray-300">
              ¡Enséñale este código QR a tus amig@s para que se registren y puedan ganar más puntos!
            </p>
          </div>
        </div>
      </div>
    );
  };
  
const FinanciarView = () => {
  return (
    <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="flex items-center mb-6">
        <DollarSign className="text-green-500 mr-3" size={32} />
        <h2 className="text-3xl font-bold text-green-500">Financiar</h2>
      </div>
      <div className="bg-gray-800 rounded-lg p-8 border-2 border-green-500/30 shadow-lg">
        <p className="mb-4 text-lg">¿Te gustaría financiar parte de una futura obra?</p>
        <p className="text-gray-300">De momento no hay obras subidas :(, pero próximamente podrás apoyarlas.</p>
      </div>
    </div>
  );
};

const DonacionView = () => {
  const [selectedAmount, setSelectedAmount] = useState(null);

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount === selectedAmount ? null : amount);
  };

  const getButtonStyle = (amount) => {
    return `px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
      amount === selectedAmount
        ? 'bg-red-600 text-white shadow-md'
        : 'bg-gray-700 text-white hover:bg-gray-600'
    }`;
  };

  return (
    <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="flex items-center mb-6">
        <Heart className="text-pink-500 mr-3" size={32} />
        <h2 className="text-4xl font-bold text-pink-500">Donación</h2>
      </div>
      <div className="bg-gray-800 rounded-lg p-8 border-2 border-pink-500/30 shadow-lg max-w-2xl">
        <p className="mb-8 text-lg text-gray-300">Si deseas, puedes colaborar con la cantidad que puedas</p>
        <div className="space-y-6">
          <div className="grid grid-cols-3 gap-4">
            <button 
              className={getButtonStyle(1000)}
              onClick={() => handleAmountSelect(1000)}
            >
              $1.000
            </button>
            <button 
              className={getButtonStyle(5000)}
              onClick={() => handleAmountSelect(5000)}
            >
              $5.000
            </button>
            <button 
              className={getButtonStyle(10000)}
              onClick={() => handleAmountSelect(10000)}
            >
              $10.000
            </button>
          </div>
          <input 
            type="text" 
            placeholder="Otro Monto" 
            className="w-full px-4 py-3 bg-gray-700 text-white border border-gray-600 rounded-lg text-lg focus:outline-none focus:border-pink-500 transition-colors"
            onChange={() => setSelectedAmount(null)}
          />
          <button className="w-full px-4 py-4 bg-red-600 hover:bg-red-700 text-white rounded-lg text-lg font-bold transition-all duration-300 shadow-md">
            ¡Adelante!
          </button>
        </div>
      </div>
    </div>
  );
};

const BuscarFinanciamientoView = () => {
  return (
    <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="flex items-center mb-6">
        <Rocket className="text-cyan-500 mr-3" size={32} />
        <h2 className="text-3xl font-bold text-cyan-500">Buscar Financiamiento</h2>
      </div>
      <div className="bg-gray-800 rounded-lg p-8 border-2 border-cyan-500/30 shadow-lg max-w-2xl">
        <p className="mb-8 text-lg">¿Te gustaría hacer realidad tu obra?</p>
        <div className="space-y-8">
          <div className="flex items-start">
            <div className="bg-cyan-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-xl mr-4 flex-shrink-0 shadow-md">
              1
            </div>
            <p className="flex-1 text-gray-300 text-lg">Adjunta un documento con un resumen de la obra, o parte del guión</p>
          </div>
          <div className="flex items-start">
            <div className="bg-cyan-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-xl mr-4 flex-shrink-0 shadow-md">
              2
            </div>
            <p className="flex-1 text-gray-300 text-lg">Revisaremos el documento y lo publicaremos para que la comunidad pueda colaborar</p>
          </div>
          <div className="pt-4">
            <p className="text-xl mb-6 font-semibold">¿Estás listo?</p>
            <button className="px-12 py-3 bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg font-bold text-lg transition-all duration-300 shadow-md">
              ¡Vamos!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CambiarContraseñaView = ({ userId }) => {
  const [passwordData, setPasswordData] = useState({
    passwordActual: '',
    nuevaPassword: '',
    confirmarPassword: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    // Validaciones
    if (!passwordData.passwordActual || !passwordData.nuevaPassword || !passwordData.confirmarPassword) {
      setMessage({ type: 'error', text: 'Todos los campos son obligatorios' });
      return;
    }

    if (passwordData.nuevaPassword !== passwordData.confirmarPassword) {
      setMessage({ type: 'error', text: 'Las contraseñas nuevas no coinciden' });
      return;
    }

    if (passwordData.nuevaPassword.length < 6) {
      setMessage({ type: 'error', text: 'La nueva contraseña debe tener al menos 6 caracteres' });
      return;
    }

    setLoading(true);

    try {
      await changePassword(
        userId,
        {
          passwordActual: passwordData.passwordActual,
          nuevaPassword: passwordData.nuevaPassword
        },
        (response) => {
          setMessage({ type: 'success', text: response.data.message || 'Contraseña cambiada exitosamente' });
          setPasswordData({ passwordActual: '', nuevaPassword: '', confirmarPassword: '' });
        },
        (error) => {
          setMessage({ type: 'error', text: error });
        }
      );
    } catch (error) {
      setMessage({ type: 'error', text: 'Error al cambiar la contraseña' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black">
      <div className="flex items-center mb-6">
        <Lock className="text-purple-500 mr-3" size={32} />
        <h2 className="text-3xl font-bold text-purple-500">Cambiar Contraseña</h2>
      </div>
      <div className="bg-gray-800 rounded-lg p-8 border-2 border-purple-500/30 shadow-lg max-w-2xl">
        {message.text && (
          <div className={`mb-6 p-4 rounded-lg flex items-center ${
            message.type === 'success' ? 'bg-green-600/20 border border-green-500/50' : 'bg-red-600/20 border border-red-500/50'
          }`}>
            {message.type === 'success' ? (
              <CheckCircle className="mr-3 text-green-500" size={20} />
            ) : (
              <AlertCircle className="mr-3 text-red-500" size={20} />
            )}
            <span className="text-white">{message.text}</span>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="passwordActual" className="block text-sm font-semibold mb-2 text-gray-300">
              Contraseña Actual
            </label>
            <input 
              type="password" 
              id="passwordActual" 
              value={passwordData.passwordActual}
              onChange={(e) => setPasswordData({...passwordData, passwordActual: e.target.value})}
              className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:border-purple-500 transition-colors" 
            />
          </div>
          
          <div>
            <label htmlFor="nuevaPassword" className="block text-sm font-semibold mb-2 text-gray-300">
              Nueva Contraseña
            </label>
            <input 
              type="password" 
              id="nuevaPassword" 
              value={passwordData.nuevaPassword}
              onChange={(e) => setPasswordData({...passwordData, nuevaPassword: e.target.value})}
              className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:border-purple-500 transition-colors" 
            />
          </div>

          <div>
            <label htmlFor="confirmarPassword" className="block text-sm font-semibold mb-2 text-gray-300">
              Confirmar Nueva Contraseña
            </label>
            <input 
              type="password" 
              id="confirmarPassword" 
              value={passwordData.confirmarPassword}
              onChange={(e) => setPasswordData({...passwordData, confirmarPassword: e.target.value})}
              className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:border-purple-500 transition-colors" 
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="mt-6 px-6 py-3 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 text-white rounded-lg font-bold text-lg w-full transition-all duration-300 shadow-md flex items-center justify-center"
          >
            {loading ? (
              <>Cambiando...</>
            ) : (
              <>
                <Lock className="mr-2" size={20} />
                Cambiar Contraseña
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

const UserProfile = () => {
  const [activeView, setActiveView] = useState('profile');
  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    country: '',
    email: '',
    phoneNumber: '',
    isPremium: false,
    habilitado: true,
    isExternal: false
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [updating, setUpdating] = useState(false);
  const [userId, setUserId] = useState(null);

  // Obtener userId del token JWT
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setMessage({ type: 'error', text: 'No se encontró token de autenticación' });
      setLoading(false);
      return;
    }
    
    try {
      const decodedToken = jwtDecode(token);
      const uid = decodedToken.oid; // El campo 'oid' contiene el userId
      setUserId(uid);
    } catch (error) {
      setMessage({ type: 'error', text: 'Error al decodificar el token de autenticación' });
      setLoading(false);
    }
  }, []);

  // Cargar datos del usuario cuando tengamos el userId
  useEffect(() => {
    if (userId) {
      loadUserData();
    }
  }, [userId]);

  const loadUserData = async () => {
    setLoading(true);
    
    try {
      await getUserById(
        userId,
        (response) => {
          const user = response.data.data;
          setUserData({
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            dateOfBirth: user.dateOfBirth ? user.dateOfBirth.split('T')[0] : '',
            country: user.country || '',
            email: user.email || '',
            phoneNumber: user.phoneNumber || '',
            isPremium: user.isPremium || false,
            habilitado: user.habilitado !== undefined ? user.habilitado : true,
            isExternal: user.isExternal || false
          });
          setLoading(false);
        },
        (error) => {
          setMessage({ type: 'error', text: 'Error al cargar los datos del usuario' });
          setLoading(false);
        }
      );
    } catch (error) {
      setMessage({ type: 'error', text: 'Error al cargar los datos del usuario' });
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({
      ...userData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });
    setUpdating(true);

    try {
      await updateUser(
        userId,
        userData,
        (response) => {
          setMessage({ type: 'success', text: 'Datos actualizados exitosamente' });
          setTimeout(() => setMessage({ type: '', text: '' }), 3000);
        },
        (error) => {
          setMessage({ type: 'error', text: error });
        }
      );
    } catch (error) {
      setMessage({ type: 'error', text: 'Error al actualizar los datos' });
    } finally {
      setUpdating(false);
    }
  };

  const menuItems = [
    { id: 'profile', label: 'Mi Perfil', icon: User, color: 'text-red-500' },
    { id: 'cambiarContraseña', label: 'Cambiar Contraseña', icon: Lock, color: 'text-purple-500' },
    { id: 'premium', label: 'Premium', icon: Crown, color: 'text-yellow-500' },
    { id: 'puntos', label: 'Mis Puntos', icon: Trophy, color: 'text-orange-500' },
    { id: 'invitar', label: 'Invita y Gana', icon: Gift, color: 'text-purple-400' },
    { id: 'financiar', label: 'Financiar', icon: DollarSign, color: 'text-green-500' },
    { id: 'donacion', label: 'Donación', icon: Heart, color: 'text-pink-500' },
    { id: 'buscarFinanciamiento', label: 'Buscar Financiamiento', icon: Rocket, color: 'text-cyan-500' },
  ];

  const renderActiveView = () => {
    if (!userId) {
      return (
        <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black">
          <div className="bg-gray-800 rounded-lg p-8 border-2 border-red-500/30 shadow-lg max-w-2xl">
            <p className="text-white text-center">No se pudo obtener la información del usuario. Por favor, inicia sesión nuevamente.</p>
          </div>
        </div>
      );
    }

    switch (activeView) {
      case 'cambiarContraseña':
        return <CambiarContraseñaView userId={userId} />;
      case 'premium':
        return <PremiumView />;
      case 'puntos':
        return <MisPuntosView />;
      case 'invitar':
        return <InvitaYGanaView />;
      case 'financiar':
        return <FinanciarView />;
      case 'donacion':
        return <DonacionView />;
      case 'buscarFinanciamiento':
        return <BuscarFinanciamientoView />;
      default:
        return (
          <div className="flex-1 p-8 bg-gradient-to-br from-gray-900 to-black">
            <div className="flex items-center mb-6">
              <User className="text-red-500 mr-3" size={32} />
              <h2 className="text-3xl font-bold text-red-500">Mi Perfil</h2>
            </div>
            
            {loading ? (
              <div className="bg-gray-800 rounded-lg p-8 border-2 border-red-500/30 shadow-lg max-w-2xl">
                <p className="text-white text-center">Cargando datos...</p>
              </div>
            ) : (
              <div className="bg-gray-800 rounded-lg p-8 border-2 border-red-500/30 shadow-lg max-w-2xl">
                {message.text && (
                  <div className={`mb-6 p-4 rounded-lg flex items-center ${
                    message.type === 'success' ? 'bg-green-600/20 border border-green-500/50' : 'bg-red-600/20 border border-red-500/50'
                  }`}>
                    {message.type === 'success' ? (
                      <CheckCircle className="mr-3 text-green-500" size={20} />
                    ) : (
                      <AlertCircle className="mr-3 text-red-500" size={20} />
                    )}
                    <span className="text-white">{message.text}</span>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold mb-2 text-gray-300">Email</label>
                    <input 
                      type="email" 
                      id="email" 
                      name="email" 
                      value={userData.email}
                      onChange={handleInputChange}
                      disabled
                      className="block w-full px-4 py-3 rounded-lg bg-gray-600 border border-gray-600 text-gray-400 cursor-not-allowed" 
                    />
                    <p className="text-xs text-gray-400 mt-1">El email no se puede modificar</p>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="firstName" className="block text-sm font-semibold mb-2 text-gray-300">Nombre</label>
                      <input 
                        type="text" 
                        id="firstName" 
                        name="firstName" 
                        value={userData.firstName}
                        onChange={handleInputChange}
                        className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:border-red-500 transition-colors" 
                      />
                    </div>
                    <div>
                      <label htmlFor="lastName" className="block text-sm font-semibold mb-2 text-gray-300">Apellido</label>
                      <input 
                        type="text" 
                        id="lastName" 
                        name="lastName" 
                        value={userData.lastName}
                        onChange={handleInputChange}
                        className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:border-red-500 transition-colors" 
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label htmlFor="dateOfBirth" className="block text-sm font-semibold mb-2 text-gray-300">Fecha de Nacimiento</label>
                    <input 
                      type="date" 
                      id="dateOfBirth" 
                      name="dateOfBirth" 
                      value={userData.dateOfBirth}
                      onChange={handleInputChange}
                      className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:border-red-500 transition-colors" 
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="country" className="block text-sm font-semibold mb-2 text-gray-300">País</label>
                    <select 
                      id="country" 
                      name="country" 
                      value={userData.country}
                      onChange={handleInputChange}
                      className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white appearance-none focus:outline-none focus:border-red-500 transition-colors" 
                      style={{
                        backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3E%3Cpath stroke=\'%23fff\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3E%3C/svg%3E")', 
                        backgroundRepeat: 'no-repeat', 
                        backgroundPosition: 'right 0.75rem center', 
                        backgroundSize: '1.5em 1.5em', 
                        paddingRight: '2.5rem'
                      }}
                    >
                      <option value="">Selecciona un país</option>
                      {paises.map((pais, index) => (
                        <option key={index} value={pais}>{pais}</option>
                      ))}
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="phoneNumber" className="block text-sm font-semibold mb-2 text-gray-300">Número de teléfono</label>
                    <input 
                      type="tel" 
                      id="phoneNumber" 
                      name="phoneNumber" 
                      value={userData.phoneNumber}
                      onChange={handleInputChange}
                      className="block w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:border-red-500 transition-colors" 
                    />
                  </div>
                  
                  <button 
                    type="submit" 
                    disabled={updating}
                    className="mt-6 px-6 py-3 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white rounded-lg font-bold text-lg w-full transition-all duration-300 shadow-md flex items-center justify-center"
                  >
                    {updating ? (
                      <>Actualizando...</>
                    ) : (
                      <>
                        <Save className="mr-2" size={20} />
                        Actualizar mis datos
                      </>
                    )}
                  </button>
                </form>
              </div>
            )}
          </div>
        );
    }
  };

  return (
    <div className="flex bg-black text-white min-h-screen">
      {/* Barra lateral con efecto neón */}
      <div className="w-72 p-6 bg-gradient-to-b from-gray-900 to-black border-r-2 border-gray-800">
        <h2 className="text-2xl font-bold mb-8 text-center bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 bg-clip-text text-transparent">
          Mi Cuenta
        </h2>
        <nav>
          <ul className="space-y-3">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.id}>
                  <button 
                    className={`w-full text-left py-3 px-4 rounded-lg transition-all duration-300 flex items-center ${
                      activeView === item.id 
                        ? 'bg-gradient-to-r from-gray-800 to-gray-900 border-l-4 border-red-500 shadow-lg' 
                        : 'hover:bg-gray-800/50 hover:translate-x-1'
                    }`}
                    onClick={() => setActiveView(item.id)}
                  >
                    <Icon className={`mr-3 ${activeView === item.id ? item.color : 'text-gray-400'}`} size={20} />
                    <span className={activeView === item.id ? 'font-semibold' : ''}>{item.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      {/* Contenido principal */}
      {renderActiveView()}
    </div>
  );
};

export default UserProfile;